<script>
    import {onMount} from "svelte";
    import {eventBridge} from "../../stores";
    import {faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
    import ConfirmModal from "./ConfirmModal.svelte";
    import Fa from "svelte-fa";

    const header = "Verbindungsprobleme";
    const message = "Es treten Probleme mit der Internetverbindung auf. Bitte versuchen Sie es später erneut.";
    let isOpen = $state(false);

    onMount(() => {
        const handleConnectionError = () => {
            isOpen = true;
        };

        $eventBridge.addEventListener("cs:ErrorConnection", handleConnectionError);

        return () => {
            $eventBridge.removeEventListener("cs:ErrorConnection", handleConnectionError);
        };
    });
</script>

<ConfirmModal
    bind:showConfirm={isOpen}
    confirm={() => (isOpen = false)}
>
    {#snippet header()}
        <Fa icon={faTriangleExclamation}/>
        {header}
    {/snippet}

    {message}
</ConfirmModal>
